export default {
    PtHeaderWidgetCaseTime: {
        tooltip: '项目计时',
    },
};
